(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmn-product-pdp"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var COLOURMAP={white:'#ffffff',black:'#111',navy:'#1f2a44','french navy':'#2b2f3a',royal:'#1f4ea1','royal blue':'#1f4ea1',red:'#c8102e',maroon:'#6e1f2e',burgundy:'#6e1f2e',bottle:'#103d2c','bottle green':'#103d2c',green:'#1e7aà¥©à¥ª'.replace('à¥©à¥ª','34'),'kelly green':'#1c7a3a',sky:'#8fc3e3','sky blue':'#8fc3e3',sapphire:'#1f6fb2','sapphire blue':'#1f6fb2',yellow:'#f5c518',orange:'#e8541e',purple:'#5b2a86',pink:'#e85aa0','hot pink':'#e6398b',grey:'#9a9a9a','heather grey':'#b8b8b8',charcoal:'#3a3a3a',sky_:'#8fc3e3'};
    function fmt(n){return '\u00A3'+(Math.round(n*100)/100).toFixed(2);}
    function tierFor(q){if(q>=100)return '100';if(q>=50)return '50';if(q>=25)return '25';return '10';}

    function init(root){
      if(!root||root.dataset.bmnInit) return; root.dataset.bmnInit='1';
      var d=root.dataset, BLANK=parseFloat(d.base)||0;
      function up(k){var v=parseFloat(d[k]);return isNaN(v)?0:v;}
      var DECO={
        embroidery:{label:'Embroidery',uplift:{'10':up('emb10'),'25':up('emb25'),'50':up('emb50'),'100':up('emb100')},setup:parseFloat(d.embsetup)||15,freeOver:parseFloat(d.setupfree)||100},
        dtf:{label:'DTF Print',uplift:{'10':up('dtf10'),'25':up('dtf25'),'50':up('dtf50'),'100':up('dtf100')}}
      };
      var TIERS=[['10','10\u201324'],['25','25\u201349'],['50','50\u201399'],['100','100+']];
      var kitQty=parseInt(d.kitqty,10)||10, WA=d.wa||'', TITLE=d.title||'this product';
      var POSITIONS=[['lc','Left chest','embroidery'],['rc','Right chest','embroidery'],['cc','Centre chest','embroidery'],['nape','Nape / neck','embroidery'],['ub','Upper back','dtf'],['fb','Full back','dtf'],['ls','Left sleeve','embroidery'],['rs','Right sleeve','embroidery']];

      var q=function(s){return root.querySelector(s);}, qa=function(s){return Array.prototype.slice.call(root.querySelectorAll(s));};
      var state={colour:'',qty:{},positions:[{id:'lc',label:'Left chest',method:'embroidery',source:'later',text:''}]};

      function totalUnits(){var t=0;for(var k in state.qty){if(state.qty.hasOwnProperty(k))t+=state.qty[k];}return t;}
      function posUnit(tier){var s=0;state.positions.forEach(function(p){s+=DECO[p.method].uplift[tier];});return s;}
      function unit(tier){return BLANK+posUnit(tier);}
      function hasPos(id){return state.positions.some(function(x){return x.id===id;});}
      function getPos(id){return state.positions.filter(function(x){return x.id===id;})[0];}

      // colour swatches
      qa('[data-swatches] .sw').forEach(function(b,i){
        var name=b.getAttribute('data-colour'); var key=name.toLowerCase();
        b.style.background=COLOURMAP[key]||'#cfcfcf';
        if(i===0) state.colour=name;
        b.addEventListener('click',function(){
          state.colour=name;
          qa('[data-swatches] .sw').forEach(function(x){x.setAttribute('aria-pressed','false');});
          b.setAttribute('aria-pressed','true');
          var cn=q('[data-colourname]'); if(cn) cn.textContent=name;
          render();
        });
      });

      // size pills
      qa('[data-sizes] .size').forEach(function(b){
        var s=b.getAttribute('data-size');
        b.addEventListener('click',function(){
          if(state.qty.hasOwnProperty(s)){delete state.qty[s];b.setAttribute('aria-pressed','false');}
          else {state.qty[s]=1;b.setAttribute('aria-pressed','true');}
          buildRows();render();
        });
      });
      var rowsWrap=q('[data-sizerows]');
      function buildRows(){
        rowsWrap.innerHTML='';
        qa('[data-sizes] .size').forEach(function(pill){
          var s=pill.getAttribute('data-size'); if(!state.qty.hasOwnProperty(s))return;
          var row=document.createElement('div');row.className='sizerow';row._size=s;
          var sz=document.createElement('div');sz.className='sizerow__sz';sz.textContent=s;
          var step=document.createElement('div');step.className='stepper';
          var minus=document.createElement('button');minus.type='button';minus.textContent='\u2212';
          var inp=document.createElement('input');inp.type='number';inp.min='0';inp.value=state.qty[s];
          var plus=document.createElement('button');plus.type='button';plus.textContent='+';
          var line=document.createElement('div');line.className='sizerow__line';
          minus.addEventListener('click',function(){setQty(s,(state.qty[s]||0)-1,false);});
          plus.addEventListener('click',function(){setQty(s,(state.qty[s]||0)+1,false);});
          inp.addEventListener('input',function(){var v=parseInt(inp.value,10);if(isNaN(v))v=0;setQty(s,v,true);});
          step.appendChild(minus);step.appendChild(inp);step.appendChild(plus);
          row.appendChild(sz);row.appendChild(step);row.appendChild(line);
          row._inp=inp;row._line=line;rowsWrap.appendChild(row);
        });
      }
      function findRow(s){var rs=qa('[data-sizerows] .sizerow');for(var i=0;i<rs.length;i++){if(rs[i]._size===s)return rs[i];}return null;}
      function setQty(s,v,fromInput){
        if(v<=0){delete state.qty[s];var pill=q('[data-sizes] .size[data-size="'+s+'"]');if(pill)pill.setAttribute('aria-pressed','false');buildRows();}
        else {state.qty[s]=v;if(!fromInput){var r=findRow(s);if(r)r._inp.value=v;}}
        render();
      }

      // positions
      var posWrap=q('[data-posgrid]');
      POSITIONS.forEach(function(P){
        var b=document.createElement('button');b.className='poschip';b.setAttribute('data-pos',P[0]);b.textContent=P[1];
        b.setAttribute('aria-pressed',hasPos(P[0])?'true':'false');
        b.addEventListener('click',function(){
          if(hasPos(P[0])){state.positions=state.positions.filter(function(x){return x.id!==P[0];});b.setAttribute('aria-pressed','false');}
          else {state.positions.push({id:P[0],label:P[1],method:P[2],source:'later',text:''});b.setAttribute('aria-pressed','true');}
          buildBLines();render();
        });
        posWrap.appendChild(b);
      });

      var blWrap=q('[data-blines]');
      function seg(opts,cur,onPick){
        var wrap=document.createElement('div');wrap.className='seg';
        opts.forEach(function(o){
          var btn=document.createElement('button');btn.type='button';
          btn.innerHTML=(o.free?'<span class="free">no setup</span>':'')+o.label;
          btn.setAttribute('aria-pressed',cur===o.value?'true':'false');
          btn.addEventListener('click',function(){wrap.querySelectorAll('button').forEach(function(z){z.setAttribute('aria-pressed','false');});btn.setAttribute('aria-pressed','true');onPick(o.value);});
          wrap.appendChild(btn);
        });
        return wrap;
      }
      function buildBLines(){
        blWrap.innerHTML='';
        state.positions.forEach(function(p){
          var card=document.createElement('div');card.className='bline';card._id=p.id;
          var head=document.createElement('div');head.className='bline__head';
          var pos=document.createElement('div');pos.className='bline__pos';pos.textContent=p.label;
          var x=document.createElement('button');x.type='button';x.className='bline__x';x.innerHTML='\u2715';
          x.addEventListener('click',function(){state.positions=state.positions.filter(function(z){return z.id!==p.id;});var chip=q('[data-posgrid] .poschip[data-pos="'+p.id+'"]');if(chip)chip.setAttribute('aria-pressed','false');buildBLines();render();});
          head.appendChild(pos);head.appendChild(x);
          var ml=document.createElement('div');ml.className='bline__label';ml.textContent='Method';
          var mseg=seg([{value:'embroidery',label:'Embroidery'},{value:'dtf',label:'DTF Print',free:true}],p.method,function(v){p.method=v;render();});
          var sl=document.createElement('div');sl.className='bline__label';sl.textContent='Artwork';
          var sseg=seg([{value:'upload',label:'Upload logo'},{value:'text',label:'Add text'},{value:'later',label:'Supply later'}],p.source,function(v){p.source=v;buildBLines();render();});
          var panel=document.createElement('div');panel.className='srcrow';
          if(p.source==='upload'){var u=document.createElement('label');u.className='upload';u.textContent='\uD83D\uDCCE Choose file \u2014 we proof it free';panel.appendChild(u);}
          else if(p.source==='text'){var t=document.createElement('input');t.className='srctext';t.placeholder='e.g. staff name, slogan or URL';t.value=p.text||'';t.addEventListener('input',function(){p.text=t.value;render();});panel.appendChild(t);}
          else {var n=document.createElement('span');n.className='srcnote';n.textContent='No problem \u2014 approve the artwork on your free mockup.';panel.appendChild(n);}
          var lp=document.createElement('div');lp.className='bline__price';card._lp=lp;
          card.appendChild(head);card.appendChild(ml);card.appendChild(mseg);card.appendChild(sl);card.appendChild(sseg);card.appendChild(panel);card.appendChild(lp);
          blWrap.appendChild(card);
        });
      }

      // thumbnails
      qa('.thumb').forEach(function(t){
        t.addEventListener('click',function(){
          var src=t.getAttribute('data-thumb');var main=q('[data-mainimg]');if(main&&src)main.src=src;
          qa('.thumb').forEach(function(x){x.setAttribute('aria-pressed','false');});t.setAttribute('aria-pressed','true');
        });
      });

      function render(){
        var tu=totalUnits(), tier=tierFor(tu>0?tu:10), u=unit(tier), dPer=posUnit(tier);
        var fromPos=state.positions.length?posUnit('100'):DECO.dtf.uplift['100'];
        var fp=q('[data-fromprice]'); if(fp)fp.textContent=fmt(BLANK+fromPos);
        var bk=q('[data-breaks]'); if(bk){bk.innerHTML='';TIERS.forEach(function(t){var s=document.createElement('span');s.className='brk'+((t[0]===tier&&tu>0)?' active':'');s.innerHTML=t[1]+'<b>'+fmt(unit(t[0]))+'</b>';bk.appendChild(s);});}
        qa('[data-blines] .bline').forEach(function(card){var p=getPos(card._id);if(p&&card._lp)card._lp.innerHTML='+ <b>'+fmt(DECO[p.method].uplift[tier])+'</b> per shirt';});
        qa('[data-sizerows] .sizerow').forEach(function(r){var qn=state.qty[r._size]||0;r._line.innerHTML=fmt(u)+' ea \u00B7 <b>'+fmt(u*qn)+'</b>';});
        var anyEmb=state.positions.some(function(p){return p.method==='embroidery';});
        var setup=0,setupTxt='';
        if(anyEmb&&tu>0){if(u*tu>DECO.embroidery.freeOver){setupTxt='Embroidery \u00A3'+DECO.embroidery.setup+' setup \u2014 waived (order over \u00A3'+DECO.embroidery.freeOver+')';}else{setup=DECO.embroidery.setup;setupTxt='Includes one-off \u00A3'+DECO.embroidery.setup+' embroidery setup (free over \u00A3'+DECO.embroidery.freeOver+')';}}
        else if(state.positions.length&&tu>0){setupTxt='No setup fee';}
        var grand=u*tu+setup;
        var e;
        e=q('[data-totalunits]');if(e)e.textContent=tu;
        e=q('[data-decoper]');if(e)e.textContent=fmt(dPer);
        e=q('[data-pershirt]');if(e)e.textContent=tu>0?fmt(u):fmt(0);
        e=q('[data-grandtotal]');if(e)e.textContent=fmt(grand);
        e=q('[data-setupline]');if(e)e.textContent=setupTxt;
        e=q('[data-kitprice]');if(e)e.textContent=fmt((BLANK+DECO.dtf.uplift['10'])*kitQty);
        qa('[data-wabtn]').forEach(function(wa){
          var sizes=[];qa('[data-sizes] .size').forEach(function(pill){var s=pill.getAttribute('data-size');if(state.qty[s])sizes.push(s+' x'+state.qty[s]);});
          var brand=state.positions.map(function(p){var src=p.source==='text'?('text: '+(p.text||'\u2014')):(p.source==='upload'?'logo to upload':'artwork to follow');return p.label+' ('+DECO[p.method].label+', '+src+')';});
          var msg='Hi Brand Me Now, quote please: '+TITLE+' \u2014 '+(state.colour||'')+(sizes.length?', '+sizes.join(', '):'')+' (total '+tu+'). Branding: '+(brand.length?brand.join('; '):'blanks')+'. Please send a free logo mockup.';
          wa.href='https://wa.me/'+WA+'?text='+encodeURIComponent(msg);
        });
      }

      buildBLines();buildRows();render();
    }

    function boot(){Array.prototype.slice.call(document.querySelectorAll('.bmn-pdp')).forEach(init);}
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
    document.addEventListener('shopify:section:load',boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtf-printing-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hero = document.querySelector('.dtf-hero__video');
  if (reduced && hero) hero.removeAttribute('autoplay');

  const lazies = document.querySelectorAll('[data-dtf-lazy]');
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const video = entry.target;
      const source = video.querySelector('source[data-src]');
      if (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.load();
      }
      if (!reduced) video.play().catch(() => {});
      io.unobserve(video);
    }
  }, { rootMargin: '200px' });
  for (const video of lazies) io.observe(video);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
